import React from 'react';
import axios from "axios";

import { Container, Grid, useMantineTheme, Box, Group, Table, ScrollArea } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { v4 as uuidv4 } from 'uuid';
import { IconReload } from '@tabler/icons-react';

import { useLoginContext } from "../../../context/loginContext";

import { BE_API_THREE, utils, role } from "../../../utils/globalVariables";
import { getPropInSubLevelRole } from "../../../utils/globalFunctions";

import ActionIconComponent from "../../../components/general/ActionIconComponent";

import NoData from "../../../components/general/NoData";
import WrapperUtils from "../../../layout/WrapperUtils";

const BobotKerjaTeknisiIndex = ({
    stateMenu,
    stateSubMenu,
    stateTab,
}) => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    // const matchesMinMD = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const [data, setData] = React.useState({
        data: [],
        dataFlag: 'idle',
        dataLoading: false,
        dataRefresh: new Date(),
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        setData(d => ({ ...d, dataLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('flag_all', utils.flagAll);
        formDT.append('project_is_cancel', '0');
        formDT.append('project_process_all', JSON.stringify(utils.projectProcess));
        formDT.append('user_level', JSON.stringify(role));

        axios({
            method: 'post',
            url: BE_API_THREE + '/bobot_kerja_teknisi',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, dataLoading: false }));

            if (response.data.flag_status === 'isset') {
                setData(d => ({
                    ...d,
                    data: response.data.data,
                    dataFlag: response.data.data.length > 0 ? true : false,
                }));
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                dataLoading: false,
            }));

            notifications.show({
                id: uuidv4(),
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }, [handleSetLoginContext, loginContext.syswebapp, data.dataRefresh])

    return (
        <React.Fragment>
            <WrapperUtils
                stateDataLoading={data.dataLoading}
            >
                <Group spacing='xs' noWrap>
                    {/* <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Filter'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({
                            ...d,
                            filterData: {
                                ...d.filterData,
                                drawer: true
                            }
                        }))}

                        StateIcon={IconFilter}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    /> */}

                    <ActionIconComponent
                        stateVariant='light'
                        stateRadius='xl'
                        stateTitle='Reload Data'
                        stateSize='lg'
                        fnOnClick={() => setData(d => ({ ...d, dataLoading: true, dataRefresh: new Date() }))}

                        StateIcon={IconReload}
                        stateIconSize='1.125rem'
                        stateIconStrokeWidth={1.25}
                        stateIconStyle={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />

                    {/* <TextInput
                        icon={data.dataSearchInputLoading ? <Loader size='1rem' /> : <IconSearch size='1rem' />}
                        variant='default'
                        size='sm'
                        radius='md'
                        placeholder='Search Project'
                        value={data.dataSearchInput}
                        onChange={(e) => setData(d => ({ ...d, dataSearchInput: e.target.value }))}

                        py={0}
                        my={0}
                    /> */}
                </Group>
            </WrapperUtils>

            <Container fluid>
                <Grid my={0}>
                    {data.data.length <= 0 && data.dataFlag !== 'idle' &&
                        <Grid.Col span={12}>
                            <NoData />
                        </Grid.Col>
                    }

                    {data.data.length > 0 &&
                        <Grid.Col
                            span={12}
                            py={0}
                        >
                            <Box mt='md'>
                                <ScrollArea>
                                    <Table
                                        highlightOnHover
                                        // border
                                        withColumnBorders
                                        verticalSpacing="sm"

                                        sx={(tema) => ({
                                            '& thead tr': {
                                                '& th': {
                                                    backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[7],
                                                },
                                                '& th:not(:last-of-type)': {
                                                    borderRightWidth: '1px',
                                                    borderRightStyle: 'solid',
                                                    borderRightColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4]
                                                }
                                            },

                                            '& tbody tr': {
                                                '& td:not(:last-of-type)': {
                                                    borderRightWidth: '1px',
                                                    borderRightStyle: 'solid',
                                                    borderRightColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4]
                                                }
                                            }
                                        })}
                                    >
                                        <thead>
                                            <tr>
                                                <th>Nama</th>
                                                <th>Jabatan</th>
                                                <th>{utils.projectProcess.nota.caption}</th>
                                                <th>{utils.projectProcess.antrian.caption}</th>
                                                <th>{utils.projectProcess.pengerjaan.caption}</th>
                                                <th>{utils.projectProcess.qc.caption}</th>
                                                <th>{utils.projectProcess.selesai.caption}</th>
                                                <th>Diambil</th>
                                                <th style={{ fontWeight: 'bold' }}>Total</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((key, idx) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>{data.data[key].user_name}</td>
                                                        <td>{getPropInSubLevelRole(data.data[key].user_sub_level, 'caption', '-')}</td>
                                                        <td>{data.data[key].nota}</td>
                                                        <td>{data.data[key].antrian}</td>
                                                        <td>{data.data[key].pengerjaan}</td>
                                                        <td>{data.data[key].qc}</td>
                                                        <td>{data.data[key].selesai}</td>
                                                        <td>{data.data[key].sudah_diambil}</td>
                                                        <td style={{ fontWeight: 'bold' }}>{data.data[key].total}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </ScrollArea>
                            </Box>
                        </Grid.Col>
                    }
                </Grid>
            </Container>
        </React.Fragment>
    )
}

export default BobotKerjaTeknisiIndex;